import { createContext, useCallback, useState } from 'react'

import { Modal } from 'antd'
import { useSelector } from 'react-redux'
import { isFunction, isArray } from 'lodash'

import { selectUser } from '../../reducers/UserReducer'
import { onError, onSuccess, resolvePromises } from '../../utils/apiHelper'
import { createSchoolSection } from '../../utils/api/school'
import { getFullAbbreviation } from '../../utils/entities/schoolSection'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import BulkSectionForm from '../../Components/shared/SchoolSectionsDrawer/BulkSectionForm'

export const SchoolSectionModalContext = createContext()

const DEFAULT_FORM_HANDLER = { data: null, callback: null }

const SchoolSectionModal = ({ children, school }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)
  const isUnmanagedSchool = school?.managed === false

  const [formHandler, setFormHandler] = useState(DEFAULT_FORM_HANDLER)

  const handleClose = useCallback(school => {
    setFormHandler(DEFAULT_FORM_HANDLER)

    if (isFunction(formHandler.callback)) {
      formHandler.callback(school)
    }
  }, [formHandler.callback])

  const handleSubmit = useCallback(sections => {
    if (sections.length > 0) {
      const promisesStack = []

      sections.forEach((section, index) => {
        promisesStack.push(createSchoolSection(user, school, section).then(({ data }) => {
          onSuccess(t('school_section.create.success.verbose', { name: getFullAbbreviation(section) }))
          return data
        }).catch(() => {
          onError(t('school_section.create.error.verbose', { name: getFullAbbreviation(section) }))

          return null
        })
        )
      })

      resolvePromises(promisesStack).then(sections => {
        handleClose(sections)
      })
    } else {
      handleClose([])
    }
  }, [t, user, handleClose, school, isUnmanagedSchool])

  return (
    <>
      <SchoolSectionModalContext.Provider value={{ formHandler, setFormHandler }}>
        {children}
      </SchoolSectionModalContext.Provider>
      <Modal
        visible={isArray(formHandler.data)}
        title={t('school_section_modal.title')}
        footer={null}
        onCancel={() => setFormHandler(DEFAULT_FORM_HANDLER)}
        bodyStyle={{ padding: '0px' }}
      >
        {isArray(formHandler.data) && (
          <BulkSectionForm
            useFooter
            onSubmit={handleSubmit}
            onCancel={() => setFormHandler(DEFAULT_FORM_HANDLER)}
          />
        )}
      </Modal>
    </>
  )
}

export default SchoolSectionModal
